import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * The driver fuelled the unit.
 */
export const fuelStopV1 = tmsEventKind(
  { category: "fuel", kind: "fuelStop", version: 1 },
  {
    refs: stopEventRefs,
    facts: {
      stopName: z.string(),
      /** What the driver reported putting in; null when the form was filed without it. */
      gallons: z.number().nullable(),
    },
  },
);

export const FuelStopV1Schema = fuelStopV1.schema;
export const FuelStopV1FactsSchema = fuelStopV1.facts;

export type FuelStopV1 = z.infer<typeof FuelStopV1Schema>;
export type FuelStopV1Facts = z.infer<typeof FuelStopV1FactsSchema>;

/** Every version of `fuelStop`, keyed by version. What `catalog.ts` places under `fuel`. */
export const fuelStop = { 1: fuelStopV1 } as const;
